<template>
  <div class="page-container">
    <el-card class="search-card" shadow="never">
      <el-form :inline="true" :model="searchForm" size="small">
        <el-form-item label="操作人">
          <el-input v-model="searchForm.admin_name" placeholder="账号关键词" clearable style="width:160px" />
        </el-form-item>
        <el-form-item label="操作模块">
          <el-select v-model="searchForm.module" placeholder="全部" clearable style="width:140px">
            <el-option v-for="m in modules" :key="m" :label="m" :value="m" />
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width:240px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button size="mini" icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card shadow="never" style="margin-top:12px">
      <div slot="header" class="card-header">
        <span>操作日志</span>
        <el-button
          v-permission="['system:log:clear']"
          type="danger"
          size="mini"
          icon="el-icon-delete"
          :loading="clearLoading"
          @click="handleClear"
        >清空日志</el-button>
      </div>

      <el-table :data="tableData" v-loading="loading" border stripe size="small">
        <el-table-column type="index" label="#" width="55" align="center" />
        <el-table-column prop="admin_name" label="操作人" width="110" />
        <el-table-column prop="module" label="模块" width="110" />
        <el-table-column prop="action" label="操作" width="110" />
        <el-table-column prop="uri" label="请求URI" min-width="160" show-overflow-tooltip />
        <el-table-column prop="ip" label="IP" width="130" />
        <el-table-column prop="status" label="状态码" width="80" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.status === 200 ? 'success' : 'danger'" size="mini">{{ row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="duration" label="耗时(ms)" width="85" align="center" />
        <el-table-column prop="created_at" label="时间" width="165" />
        <el-table-column label="参数" width="70" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" @click="showParams(row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrap">
        <el-pagination
          background
          :current-page="page"
          :page-size="pageSize"
          :page-sizes="[20, 50, 100]"
          :total="total"
          layout="total, sizes, prev, pager, next"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </el-card>

    <!-- 参数详情弹窗 -->
    <el-dialog title="请求参数" :visible.sync="paramsVisible" width="600px">
      <pre class="params-pre">{{ currentParams }}</pre>
    </el-dialog>
  </div>
</template>

<script>
import { getLogList, clearLogs, getLogModules } from '@/api/operation-log'

export default {
  name: 'OperationLog',
  data() {
    return {
      loading: false,
      clearLoading: false,
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 20,
      modules: [],
      dateRange: [],
      searchForm: {
        admin_name: '',
        module: ''
      },
      paramsVisible: false,
      currentParams: ''
    }
  },
  created() {
    this.fetchModules()
    this.fetchData()
  },
  methods: {
    async fetchModules() {
      try {
        const res = await getLogModules()
        this.modules = res.data || []
      } catch {}
    },
    async fetchData() {
      this.loading = true
      try {
        const params = {
          ...this.searchForm,
          per_page: this.pageSize,
          page: this.page
        }
        if (this.dateRange && this.dateRange.length === 2) {
          params.start_date = this.dateRange[0]
          params.end_date = this.dateRange[1]
        }
        const res = await getLogList(params)
        this.tableData = res.data.list || []
        this.total = res.data.total || 0
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.page = 1
      this.fetchData()
    },
    handleReset() {
      this.searchForm = { admin_name: '', module: '' }
      this.dateRange = []
      this.page = 1
      this.fetchData()
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.page = 1
      this.fetchData()
    },
    handlePageChange(page) {
      this.page = page
      this.fetchData()
    },
    async handleClear() {
      try {
        await this.$confirm('确定要清空所有操作日志吗？此操作不可恢复！', '警告', {
          type: 'warning',
          confirmButtonText: '确定清空',
          confirmButtonClass: 'el-button--danger'
        })
        this.clearLoading = true
        const res = await clearLogs()
        this.$message.success(res.message || '清空成功')
        this.page = 1
        this.fetchData()
      } catch {} finally {
        this.clearLoading = false
      }
    },
    showParams(row) {
      try {
        this.currentParams = JSON.stringify(JSON.parse(row.params || '{}'), null, 2)
      } catch {
        this.currentParams = row.params || ''
      }
      this.paramsVisible = true
    }
  }
}
</script>

<style scoped>
.page-container { padding: 16px; }
.card-header { display: flex; justify-content: space-between; align-items: center; }
.pagination-wrap { margin-top: 16px; text-align: right; }
.params-pre {
  background: #f5f7fa;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 12px;
  font-size: 12px;
  max-height: 400px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-all;
}
</style>
